import {Transition} from '@uirouter/core';
import {LoginPageComponent} from "./login-page";
import {RestorePageComponent} from "./restore-page";
import {SignUpPageComponent} from "./signup-page";
import {ApiService} from "../utils/api.service";

export const LoginState = {
    name: 'login',
    url: '/login?promo&auth&error&username&access_token',
    component: LoginPageComponent,
    page: 'login',
    title: 'Sign In',

    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.username){
                    params.username = decodeURIComponent(params.username);
                }

                if (params.error){
                    params.error = decodeURIComponent(params.error).replace(/\+/gi,' ');
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};

export const RestoreState = {
    name: 'restore',
    url: '/restore/:step?promo&type&username&password_reset_token&auth&error&oauth&client_id&client_secret&redirect_uri&response_type&page&source',
    component: RestorePageComponent,
    page: 'restore',
    title: 'Password Management',

    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.username){
                    params.username = decodeURIComponent(params.username);
                }
                if (params.redirect_uri){
                    params.redirect_uri = decodeURIComponent(decodeURIComponent(params.redirect_uri));
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};

export const SignUpState = {
    name: 'sign_up',
    url: '/sign_up?auth&error&oauth&client_id&client_secret&redirect_uri&response_type&page&promo',
    component: SignUpPageComponent,
    page: 'sign_up',
    title: 'Sign Up',
    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.redirect_uri){
                    params.redirect_uri = decodeURIComponent(decodeURIComponent(params.redirect_uri));
                }

                if (params.error){
                    params.error = decodeURIComponent(params.error).replace(/\+/gi,' ');
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};